(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/mini-meta-column-header.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/mini-meta-column-header.js');

'use strict';

const {
  infoTypes
} = svs.racing.common.constants;
const {
  gametypeHasIoDistribution
} = svs.racing.common.util;
const {
  ReactIcon,
  ReactIconButton
} = svs.ui;
const {
  useCallback
} = React;
const MiniMetaColumnHeader = _ref => {
  let {
    gameType,
    getHeaderByGameType,
    type,
    header,
    hasExplanation,
    onClickHelp
  } = _ref;
  const handleClickHelp = useCallback(event => {
    onClickHelp(event, type);
  }, [onClickHelp, type]);
  if (type === infoTypes.ODDS_LATEST) {
    return React.createElement("div", {
      className: "main-header ".concat(type === infoTypes.ODDS_LATEST ? 'span-over-odds-ref' : '')
    }, header);
  }
  if (type === infoTypes.ODDS_REF) {
    return React.createElement("span", null, "\xA0");
  }
  if (type === infoTypes.IO_DISTRIBUTION) {
    const header = getHeaderByGameType[gameType] || null;
    return gametypeHasIoDistribution(gameType) && header;
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "main-header ".concat(type === infoTypes.START_GATE || type === infoTypes.LAST_PERFORMANCE || type === infoTypes.PERCENT ? 'multi-line' : '')
  }, header), hasExplanation && React.createElement("div", {
    className: "mini-meta-explanation"
  }, React.createElement(ReactIconButton, {
    className: "icon-button padding-xs-h mini-meta-help-btn",
    onClick: handleClickHelp
  }, React.createElement(ReactIcon, {
    color: "fc-sport",
    icon: "help",
    size: "300"
  }))));
};
svs.racing_game.components.play.MiniMetaColumnHeader = MiniMetaColumnHeader;

 })(window);